
import React, { useEffect, useState, useCallback } from 'react'
import { Row, Table, Button, Col, Form, Modal, message, Tag, Input } from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { findCategoryAttributes, unBindCategoryAttributes } from '@services/attributeService'
import CategorySelect from '@components/CategorySelect'
import CategoryAttributeMappingEdit from '../../../containers/categoryAttributeMappingEdit'
import { showError } from '@utils/alert'
import moment from 'moment'

const { confirm } = Modal
const PAGE_SIZE = 10

function CategoryAttributeList() {
  const [form] = Form.useForm()
  const [tableLoading, setTableLoading] = useState(false)
  const [dialogVisible, setDialogVisible] = useState(false)
  const [items, setItems] = useState<any>(null)
  const [current, setCurrent] = useState(1)
  const [total, setTotal]: [any, any] = useState()
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [currentItem, setCurrentItem] = useState<any>(null)

  function onEdit(r?: any) {
    if (dialogVisible) return
    setCurrentItem(r)
    setDialogVisible(true)
  }

  function onDelete(record) {
    const { category_id, origin } = record
    confirm({
      title: '删除',
      content: `确认删除分类: ${category_id} 跟属性项 ${origin.id} 的关联吗？`,
      okText: '确认',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        const hide = message.loading('删除中...')
        unBindCategoryAttributes(
          [{
            category_id: category_id,
            item_ids: [origin.id],
          }]
        )
        .then(() => {
          hide()
          message.success(`删除分类:${category_id} 跟属性项:${origin.id} 关联成功`)
          searchCategoryAttribute(form, current)
        })
        .catch(e => {
          hide()
          console.error(e)
          showError(e)
        })
      },
      onCancel() {
        
      },
    })
  }

  const columns: any[] = [
    {
      title: 'Category Id',
      dataIndex: 'category_id',
      width: 120,
    }, {
      title: 'Attribute Item',
      dataIndex: ['origin', 'value'],
      key: 'value',
      width: 150,
    }, {
      title: 'Item Id',
      dataIndex: ['origin', 'id'],
      key: 'id',
      width: 100,
    }, {
      title: 'Display',
      dataIndex: ['origin', 'display_name'],
      width: 100,
    }, {
      title: 'Attribute Values',
      dataIndex: ['origin', 'childrens'],
      width: 250,
      render: (childrens) => {
        return childrens?.map(attrValue => {
          return <Tag key={attrValue.value}>{attrValue.value}</Tag>
        }) || null
      }
    }, {
      title: 'Created At',
      dataIndex: ['origin', 'created_at'],
      width: 150,
      render: (record) => {
        return moment(record).format('YYYY-MM-DD HH:mm')
      }
    }, {
      title: 'Last Modified',
      dataIndex: ['origin', 'last_modified_at'],
      width: 150,
      render: (record) => {
        return moment(record).format('YYYY-MM-DD HH:mm')
      }
    }, {
      title: 'Actions',
      width: 160,
      fixed: 'right',
      render: (record) => (
        <Row>
          <Col span={12}>
            <Button type="primary" onClick={() => onEdit(record)}>编辑</Button>
          </Col>
          <Col span={12}>
            <Button danger onClick={() => onDelete(record)}>删除</Button>
          </Col>
        </Row>
      )
    }
  ]

  const onRowSelectionChange = useCallback((keys) => {
    setSelectedRowKeys(keys)
  }, [])

  const onDeleteSelectedRows = () => {
    if (!selectedRowKeys?.length) return
    // from key to selected items
    const deletedItemMap = selectedRowKeys.map((k: string) => {
      const keys = k.split(':')
      return {
        category_id: keys[0],
        item_id: keys[1],
      }
    })
    .reduce((curr, prev) => {
      if (!curr[prev.category_id]) {
        curr[prev.category_id] = [prev.item_id]
      } else {
        curr[prev.category_id].push(prev.item_id)
      }
      return curr
    }, {})
    const deletedItems: any[] = []
    Object.keys(deletedItemMap).forEach(key => {
      if (deletedItemMap[key]?.length) {
        deletedItems.push({
          category_id: key,
          item_ids: deletedItemMap[key],
        })
      }
    })
    confirm({
      title: '删除',
      content: `确认删除所选分类跟属性项的关联吗？`,
      okText: '确认',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        const hide = message.loading('删除中...')
        unBindCategoryAttributes(deletedItems)
        .then(() => {
          hide()
          setSelectedRowKeys([])
          message.success(`删除所选分类跟属性项关联成功`)
          searchCategoryAttribute(form, current)
        })
        .catch(e => {
          hide()
          console.error(e)
          showError(e)
        })
      },
      onCancel() {
        
      },
    })
  }

  const searchCategoryAttribute = useCallback((form, current) => {
    form.validateFields().then((values) => {
      setTableLoading(true)
      const from = (current - 1) * PAGE_SIZE
      const to = current * PAGE_SIZE
      findCategoryAttributes(from, to, values.ids, values.item, values.value)
        .then(res => {
          setItems([])
          setTotal(0)
          if (res.data) {
            if (Array.isArray(res.data.items)) {
              const items: any[] = []
              res.data.items.forEach((cateAttrItem: any) => {
                cateAttrItem.attr_set?.items?.forEach(item => {
                  if (values.item && item.value.indexOf(values.item) === -1) return false
                  if (values.value && item.childrens) {
                    let skipThisCateAttr = true
                    item.childrens.forEach(attrValue => {
                      if (attrValue.value.indexOf(values.value) !== -1) {
                        skipThisCateAttr = false
                      }
                    })
                    if (skipThisCateAttr) return false
                  }
                  items.push({
                    key: cateAttrItem.category_id + ':' + item.id,
                    category_id: cateAttrItem.category_id,
                    origin: item,
                  })
                })
              })
              setItems(items)
            }
            setTotal(res.data.total)
          }
          setTableLoading(false)
        })
        .catch(e => {
          showError(e)
          setTableLoading(false)
          console.error(e)
        })
    })
  }, [])

  useEffect(() => {
    searchCategoryAttribute(form, current)
  }, [])

  return (
    <div className="p-attributes">
      <Form layout="inline" name="category-attr" form={form}>
        <Form.Item label="Category Id" name="ids">
          <CategorySelect leafOnly multiple placeholder="请选择分类 id" />
        </Form.Item>
        <Form.Item label="Attr. Item" name="item">
          <Input placeholder="请输入属性项" />
        </Form.Item>
        <Form.Item label="Attr. Value" name="value">
          <Input placeholder="请输入属性值" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={() => {
            setCurrent(1)
            searchCategoryAttribute(form, 1)
          }}>
            查询
          </Button>
        </Form.Item>
        <Form.Item>
          <Button icon={<SaveOutlined />} onClick={e => onEdit()}>
            新建
          </Button>
        </Form.Item>
      </Form>
      <Table
        style={{ backgroundColor: '#ffffff', minHeight: 400 }}
        tableLayout="fixed"
        columns={columns}
        dataSource={items}
        loading={tableLoading}
        scroll={{ x: 1300 }}
        rowKey={(record: any) => record.key}
        rowSelection={{
          selectedRowKeys,
          onChange: onRowSelectionChange,
        }}
        pagination={{
          pageSize: PAGE_SIZE,
          total: total,
          showQuickJumper: true,
          current: current,
          onChange: (page) => {
            setCurrent(page)
            searchCategoryAttribute(form, page)
          }
        }}
        footer={() => {
          return (
            <div>
              <Button
                onClick={onDeleteSelectedRows}
                disabled={!selectedRowKeys?.length}
              >
                删除选择
              </Button>
            </div>
          )
        }}
      />
      <CategoryAttributeMappingEdit
        categoryItem={currentItem}
        visible={dialogVisible}
        onCancel={() => {
          setDialogVisible(false)
          setCurrentItem(null)
          searchCategoryAttribute(form, current)
        }}
      />
    </div>
  )
}

export default CategoryAttributeList
